import { get } from '@/helpers';

export const sortingOrders = {
    color: [],
    size: [
        '1',
        '2',
        '4-6',
        '6-8',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '36',
        '38',
        '40',
        '42',
        '44',
        '46',
        '70',
        '75',
        '80',
        '85',
        '90',
        '95',
        '100',
        '105',
        'XXS',
        'XS',
        'XS/S',
        'S',
        'S/M',
        'M',
        'M/L',
        'L',
        'L/XL',
        'XL',
        'XL/XXL',
        'XXL',
        '2XL',
        'XXXL',
        '3XL',
        'OS'
    ]
};

export const getShippingFee = shippingMethod => {
    let fee = 0;
    switch (shippingMethod.price_type) {
        case 'flat-rate':
            fee = get(shippingMethod, 'mainPrice.value', 0);
            break;

        case 'country':
            // TODO
            break;

        // TODO
        // process other price types
    }
    return fee;
};

export const getPropertyValues = pivot => {
    const property = pivot?.property;
    const valueField = pivot?.property?.propType?.value_field;
    const valueFieldAlt = pivot?.property?.propType?.value_field_alt;

    const values = pivot?.values || [];
    // return values.map(el => ({ label: property.name, value: el[valueField] || el[valueFieldAlt] }))

    return { label: property?.name, values: values.map(el => el[valueField] || el[valueFieldAlt]) };
};
